import { Users, Rocket, PartyPopper, Heart, BookOpen, Info, HelpCircle, Gift, Sparkles, Star, FileText, Mail, LucideIcon, Cake, Baby, GemIcon, Flower2, Crown, Download, Landmark, Building2, Award } from 'lucide-react';

export interface MenuItemConfig {
  title: string;
  path: string;
  icon: LucideIcon;
  tagline: string;
  accentColor: string;
  bgGradient: string;
}

export interface MenuSectionConfig {
  label: string;
  mainPath: string;
  items: MenuItemConfig[];
  footerCta?: {
    label: string;
    path: string;
  };
}

// Configuration des menus pour chaque section
export const menuConfigs: Record<string, MenuSectionConfig> = {
  particuliers: {
    label: 'Particuliers',
    mainPath: '/univers-particuliers',
    items: [
      {
        title: 'Wedding Planning',
        path: '/univers-particuliers/wedding-planning-paris',
        icon: Heart,
        tagline: 'Organisation complète de votre mariage',
        accentColor: '#E8A4A4',
        bgGradient: 'from-[#E8A4A4]/5 to-transparent'
      },
      {
        title: 'Wedding Design & Scénographie',
        path: '/univers-particuliers/wedding-design-scenographie',
        icon: Crown,
        tagline: 'Décoration et mise en scène sur-mesure',
        accentColor: '#C9A227',
        bgGradient: 'from-[#C9A227]/5 to-transparent'
      },
      {
        title: 'Anniversaire Signature',
        path: '/univers-particuliers/anniversaire-signature',
        icon: PartyPopper,
        tagline: 'Fêtez vos années avec style',
        accentColor: 'hsl(var(--primary))',
        bgGradient: 'from-[#1E3A5F]/5 to-transparent'
      },
      {
        title: 'Demande en Mariage',
        path: '/univers-particuliers/demande-mariage-paris',
        icon: GemIcon,
        tagline: 'Un moment inoubliable sur-mesure',
        accentColor: '#E8A4A4',
        bgGradient: 'from-[#E8A4A4]/5 to-transparent'
      }
    ],
    footerCta: {
      label: 'Découvrir nos évènements privés',
      path: '/univers-particuliers'
    }
  },
  professionnels: {
    label: 'Professionnels',
    mainPath: '/evenement-entreprise-prestige',
    items: [
      {
        title: 'Séminaires & Team Building',
        path: '/professionnels/evenements/seminaire-team-building-prestige',
        icon: Users,
        tagline: 'Investissez dans votre capital humain',
        accentColor: 'hsl(var(--primary))',
        bgGradient: 'from-[#1E3A5F]/5 to-transparent'
      },
      {
        title: 'Évènements clients & Lancements de produits',
        path: '/professionnels/evenements/conference-evenement-client',
        icon: Rocket,
        tagline: 'Créez l\'évènement qui marque les esprits',
        accentColor: '#C9A227',
        bgGradient: 'from-[#C9A227]/5 to-transparent'
      },
      {
        title: 'Soirées d\'Entreprise',
        path: '/professionnels/evenements/soiree-entreprise-paris',
        icon: PartyPopper,
        tagline: 'Célébrez vos succès avec élégance',
        accentColor: '#E8A4A4',
        bgGradient: 'from-[#E8A4A4]/5 to-transparent'
      }
    ],
    footerCta: {
      label: 'Découvrir tous nos évènements B2B',
      path: '/evenement-entreprise-prestige'
    }
  },
  collectivites: {
    label: 'Collectivités',
    mainPath: '/evenementiel-collectivites',
    items: [
      {
        title: 'Évènements institutionnels',
        path: '/evenementiel-collectivites',
        icon: Landmark,
        tagline: 'Cérémonies, inaugurations, vœux, commémorations',
        accentColor: 'hsl(var(--primary))',
        bgGradient: 'from-[#1E3A5F]/5 to-transparent'
      },
      {
        title: 'Évènements de mairie',
        path: '/organisation-evenement-mairie-paris',
        icon: Building2,
        tagline: 'Vie municipale, fêtes de ville, évènements citoyens',
        accentColor: '#C9A227',
        bgGradient: 'from-[#C9A227]/5 to-transparent'
      },
      {
        title: 'Cérémonies & inaugurations',
        path: '/ceremonies-officielles-inaugurations-idf',
        icon: Award,
        tagline: 'Protocole, élégance républicaine, sur-mesure',
        accentColor: '#E8A4A4',
        bgGradient: 'from-[#E8A4A4]/5 to-transparent'
      }
    ],
    footerCta: {
      label: 'Découvrir notre accompagnement collectivités',
      path: '/evenementiel-collectivites'
    }
  },
  support: {
    label: 'Support & Documentation',
    mainPath: '/support',
    items: [
      {
        title: 'Notre Blog',
        path: '/blog',
        icon: BookOpen,
        tagline: 'Actualités et conseils évènementiels',
        accentColor: 'hsl(var(--primary))',
        bgGradient: 'from-[#F28C8C]/5 to-transparent'
      },
      {
        title: 'À propos',
        path: '/a-propos',
        icon: Info,
        tagline: 'Découvrez notre histoire et nos valeurs',
        accentColor: '#1E3A5F',
        bgGradient: 'from-[#1E3A5F]/5 to-transparent'
      },
      {
        title: 'FAQ',
        path: '/faq',
        icon: HelpCircle,
        tagline: 'Réponses à vos questions fréquentes',
        accentColor: '#C9A227',
        bgGradient: 'from-[#C9A227]/5 to-transparent'
      },
      {
        title: 'Charte d\'Excellence Responsable',
        path: '/charte-excellence',
        icon: FileText,
        tagline: 'Notre engagement RSE',
        accentColor: '#22C55E',
        bgGradient: 'from-[#22C55E]/5 to-transparent'
      },
      {
        title: 'Nous contacter',
        path: '/contact',
        icon: Mail,
        tagline: 'Nous contacter',
        accentColor: '#1E3A5F',
        bgGradient: 'from-[#1E3A5F]/5 to-transparent'
      },
      {
        title: 'Notre prospectus particuliers',
        path: '/prospectus-particuliers',
        icon: Download,
        tagline: 'Recevez notre brochure par email',
        accentColor: '#C9A227',
        bgGradient: 'from-[#C9A227]/5 to-transparent'
      },
      {
        title: 'Notre prospectus professionnels',
        path: '/prospectus-professionnels',
        icon: Download,
        tagline: 'Notre brochure entreprise par email',
        accentColor: '#C9A227',
        bgGradient: 'from-[#C9A227]/5 to-transparent'
      }
    ],
    footerCta: {
      label: 'Accéder au centre d\'aide',
      path: '/faq'
    }
  }
};

// Helper pour obtenir la config d'un menu par son label
export const getMenuConfigByLabel = (label: string): MenuSectionConfig | null => {
  const key = label.toLowerCase().replace(/\s+/g, '').replace('&', '');

  if (label.toLowerCase() === 'particuliers') return menuConfigs.particuliers;
  if (label.toLowerCase() === 'professionnels') return menuConfigs.professionnels;
  if (label.toLowerCase().startsWith('collectivit')) return menuConfigs.collectivites;
  if (label.toLowerCase().includes('support')) return menuConfigs.support;

  return null;
};

// Lien "Télécharger un prospectus" propre à chaque audience, injecté en bas
// des items des onglets Particuliers / Professionnels (sous les évènements).
export const prospectusMenuItems: Record<'particuliers' | 'professionnels' | 'collectivites', MenuItemConfig> = {
  particuliers: {
    title: 'Télécharger un prospectus',
    path: '/prospectus-particuliers',
    icon: Download,
    tagline: 'Recevez notre brochure par email',
    accentColor: '#C9A227',
    bgGradient: 'from-[#C9A227]/5 to-transparent'
  },
  professionnels: {
    title: 'Télécharger un prospectus',
    path: '/prospectus-professionnels',
    icon: Download,
    tagline: 'Notre brochure entreprise par email',
    accentColor: '#C9A227',
    bgGradient: 'from-[#C9A227]/5 to-transparent'
  },
  collectivites: {
    title: 'Télécharger un prospectus',
    path: '/prospectus-collectivites',
    icon: Download,
    tagline: 'Notre brochure secteur public par email',
    accentColor: '#C9A227',
    bgGradient: 'from-[#C9A227]/5 to-transparent'
  }
};

// Ajoute le lien prospectus en fin d'items pour les onglets concernés, sans
// doublon. Fonctionne que les items viennent de la DB ou du fallback statique.
export const appendProspectus = (
  config: MenuSectionConfig | null,
  label: string
): MenuSectionConfig | null => {
  if (!config) return config;
  const key = label.toLowerCase();
  const item =
    key === 'particuliers' ? prospectusMenuItems.particuliers :
    key === 'professionnels' ? prospectusMenuItems.professionnels :
    key.startsWith('collectivit') ? prospectusMenuItems.collectivites :
    null;
  if (!item) return config;
  if (config.items.some((i) => i.path === item.path)) return config;
  return { ...config, items: [...config.items, item] };
};
